import Seller from "./From/Seller";
import Source from "./From/Source";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Invoice from "./Invoice";
import Payment from "./Payment";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import Buttons from "../Elements/Buttons";
import List from "./List";
import TargetList from "./Picking/TargetList";


export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                <Buttons {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <Seller {...componentProps} />
                        </div>
                        <div className="col-md-6">
                            <Target {...componentProps} />
                        </div>
                    </div>
                    <div className="row form-row">
                        <Shipping {...componentProps} />
                    </div>
                     <Invoice {...componentProps} default="seller"/>
                    <div className="row form-row">
                        <Payment {...componentProps} />
                    </div>
                    <Comment {...componentProps} />
                    <TargetList {...componentProps} />
                </form>
            }
        </Editor>
    </Fragment>;
}